import * as googleApiServices from '@/services/googleApiServices';

export default {
  namespaced: true,
  state: {
    news: []
  },
  mutations: {
    loadNews(state, news) {
      state.news = news;
    }
  },
  actions: {
    async loadNews({ commit }) {
      const news = await googleApiServices.getNews(10);
      commit('loadNews', news);
    }
  }
};
